import { Context } from 'src/context'
import { useContext, useRef, useState } from 'react'
import PhoneInput, { isPossiblePhoneNumber, formatPhoneNumber } from 'react-phone-number-input/input'
import { motion } from 'framer-motion'
import { InvisibleSmartCaptcha  } from '@yandex/smart-captcha';


const API_GATEWAY= 'https://d5dhc2qok798ffnh3ktu.0ly8ed4d.apigw.yandexcloud.net'


export default function CoursesPage()
{
    const { set_popup_showing, popup_ids } = useContext(Context)

    const [phone_value, set_phone_value] = useState('')
    const [invalid_fio, set_invalid_fio] = useState(false)
    const [invalid_phone, set_invalid_phone] = useState(false)
    const fio_value = useRef(null)

    const pending_lead = useRef(null) // form data captured at submit time
    const [captcha_visible, set_captcha_visible] = useState(false)
    const [is_sending, set_is_sending] = useState(false)
    
    const regex_for_full_name = /^[А-Яа-яЁё]+ [А-Яа-яЁё]+ [А-Яа-яЁё]+$/
    const label_variants = {
        default: {
            "--pseudo_transform_value": "0%",
            "--pseudo_opacity_value": 0
        },
        invalid: {
            "--pseudo_transform_value": "100%",
            "--pseudo_opacity_value": 1
        }
    }

    const show_popup = (popup_id) => {
        document.querySelector(`#${popup_id}`).showModal()
        set_popup_showing(true)
    }

    const send_lead = async (captcha_token) => {
        set_is_sending(true)
        try {
            const response = await fetch(API_GATEWAY + '/api/message', {
                method: "POST",
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({
                    ...pending_lead.current,
                    'captcha_token': captcha_token
                })
            })
            show_popup(response.ok ? popup_ids.CoursesPageSuccess : popup_ids.CoursesPageError)
        } catch {
            show_popup(popup_ids.CoursesPageError)
        } finally {
            set_is_sending(false)
        }
    }

    const handle_captcha_success = (token) => {
        set_captcha_visible(false)  // reset
        send_lead(token)
    }

    const handle_captcha_error = () => {
        set_captcha_visible(false)  // reset
        show_popup(popup_ids.CoursesPageError)
    }

    return (
        <form id="courses_page_form" 
        onSubmit={ async (event) => {
            event.preventDefault()
            if (is_sending || captcha_visible) return

            if (!regex_for_full_name.test(fio_value.current.value)) {
                set_invalid_fio(true)
                return
            }

            if (!isPossiblePhoneNumber(phone_value, "RU")) {
                set_invalid_phone(true)
                return
            }

            pending_lead.current = {
                'full_name': fio_value.current.value,
                'phone_number': formatPhoneNumber(phone_value)
            }
            set_captcha_visible(true) // starts the check, result arrives in onSuccess
        } }>
            <p>Мы позвоним вам, определим ваш уровень языковых навыков и подберем подходящий для вас курс, а также ответим на все интересующие вопросы.
            </p>

            <motion.label
            variants={label_variants}
            animate={invalid_fio ? "invalid" : "default"}
            transition={ {duration: 1, type: 'spring', bounce: 0.5} }>
                <strong>ФИО</strong>
                <input className={invalid_fio ? "invalid_input" : ""}
                type="text" 
                placeholder="Иванов Иван Иванович" 
                ref={fio_value}
                onChange={ () => {
                    invalid_fio ? set_invalid_fio(false) : null
                } }
                maxLength={500}/>
            </motion.label>
            
            <motion.label
            variants={label_variants}
            animate={invalid_phone ? "invalid" : "default"}
            transition={ {duration: 1, type: 'spring', bounce: 0.5} }>
                <strong>Номер телефона</strong>
                <PhoneInput className={invalid_phone ? "invalid_input" : ""}
                country='RU'
                international={true}
                withCountryCallingCode={true}
                value={phone_value}
                onChange={ (value) => { 
                    invalid_phone ? set_invalid_phone(false) : null
                    set_phone_value(value)
                } }
                maxLength={16}/>
            </motion.label>

            <motion.button
            disabled={is_sending}
            whileTap={ { scale: 0.98 } }
            transition={ {duration: 0.025, ease: "easeOut"} }>
                <strong>{is_sending ? "Отправка..." : "Оставить заявку"}</strong>
            </motion.button>

            <InvisibleSmartCaptcha
                sitekey='ysc1_ofNSkRSsHk2LilVh1LwHTV7GYWFesap5cxftxPE518eb84b0'  // public, safe to keep in the bundle
                visible={captcha_visible}
                language="ru"
                hideShield={true}
                onSuccess={handle_captcha_success}
                onChallengeHidden={() => set_captcha_visible(false)}
                onNetworkError={handle_captcha_error}
                onJavascriptError={handle_captcha_error}
            />
        </form>
    )
}